module.exports = __webpack_public_path__ + "img/Latvia.a524902e.png";